import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import typography from "assets/theme/base/typography";

// Images
import error404 from "assets/images/illustrations/error-404.png";
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";

function Error404() {
  const { d1, d3, d4, d5 } = typography;

  return (
    <>
      <div style={{
        padding: "8px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "var(--main-bg-color)"
      }}>
        <DashboardNavbar />
      </div>
      <DashboardLayout>
        <SoftBox p={2}>
          <SoftBox height="calc(100vh - 24rem)">
            <Grid
              container
              spacing={3}
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%" }}
            >
              <Grid size={{ xs: 11, sm: 9 }} container alignItems="center">
                <Grid size={{ xs: 12, lg: 6 }}>
                  <SoftBox
                    fontSize={{ xs: d5.fontSize, sm: d4.fontSize, md: d3.fontSize, lg: d1.fontSize }}
                    lineHeight={1.2}
                  >
                    <SoftTypography variant="inherit" color="warning" textGradient fontWeight="bold">
                      Page Under Maintenance
                    </SoftTypography>
                  </SoftBox>
                  <SoftTypography variant="h2" color="dark" textGradient fontWeight="bold">
                    Sorry for the inconvinience
                  </SoftTypography>
                  <SoftBox mt={1} mb={2}>
                    <SoftTypography variant="body1" color="text">
                      We suggest you to go to the homepage while we are currently working on it.
                      Thanks!
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox mt={4} mb={2}>
                    <SoftButton component={Link} to="/home" variant="gradient" color="dark">
                      go to homepage
                    </SoftButton>
                  </SoftBox>
                </Grid>
                <Grid size={{ xs: 12, lg: 6 }}>
                  <SoftBox component="img" src={error404} alt="error-404" width="100%" />
                </Grid>
              </Grid>
            </Grid>
          </SoftBox>
        </SoftBox>
      </DashboardLayout>
    </>
  );
}

export default Error404;
